import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardTopbar from '../../components/DashboardTopbar';
import PhysicalTrainingPanel from './PhysicalTrainingPanel';
import './PhysicalTraining.css';

function PhysicalTraining() {
  const navigate = useNavigate();

  return (
    <div className="App dashboard-page physical-training-page">
      <DashboardTopbar label="Treino físico" />

      <PhysicalTrainingPanel />
    </div>
  );
}

export default PhysicalTraining;
